import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@material-ui/core';

/**
 * Row selection checkbox driven by parent selection state (not DataGrid internal selection).
 */
export const QueueSelectCell = ({ checked, disabled, onToggle, ariaLabel }) => (
  <Checkbox
    checked={checked}
    disabled={disabled}
    onChange={onToggle}
    color="primary"
    inputProps={{ 'aria-label': ariaLabel }}
  />
);

QueueSelectCell.propTypes = {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
};
